
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/science-figures/jp",
      function () {
        return require("private-next-pages/science-figures/jp.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/science-figures/jp"])
      });
    }
  